module.exports = __webpack_public_path__ + "static/media/cloudy.12dd0e85.png";